import { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AdminNavbar() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `block md:inline-block text-sm font-semibold pb-1 border-b-2 ${
      isActive
        ? 'text-brolax-red border-brolax-red'
        : 'border-transparent text-gray-400 hover:text-white'
    }`;

  return (
    <nav className="bg-black text-white border-b-2 border-brolax-red sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 font-black text-xl tracking-widest shrink-0">
          <span>BROLAX</span>
          <span className="bg-brolax-red px-2 py-0.5 rounded text-sm">BX</span>
          <span className="text-gray-400 text-sm font-medium mr-3 hidden sm:inline">لوحة التحكم</span>
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-6">
          <NavLink to="/" end className={linkClass}>الرئيسية</NavLink>
          <NavLink to="/products" className={linkClass}>المنتجات</NavLink>
          <NavLink to="/orders" className={linkClass}>الطلبات</NavLink>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => { logout(); navigate('/login'); }}
            className="hidden md:block border border-gray-600 text-gray-300 px-4 py-1.5 rounded text-sm hover:border-brolax-red hover:text-brolax-red transition"
          >
            تسجيل خروج
          </button>

          {/* Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden flex flex-col gap-1.5 p-1"
          >
            <span className={`block w-6 h-0.5 bg-white transition ${mobileOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-white transition ${mobileOpen ? 'opacity-0' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-white transition ${mobileOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-neutral-900 border-t border-neutral-800 px-4 py-4 space-y-3">
          <NavLink to="/" end onClick={() => setMobileOpen(false)} className={linkClass}>الرئيسية</NavLink>
          <NavLink to="/products" onClick={() => setMobileOpen(false)} className={linkClass}>المنتجات</NavLink>
          <NavLink to="/orders" onClick={() => setMobileOpen(false)} className={linkClass}>الطلبات</NavLink>
          <button
            onClick={() => { logout(); navigate('/login'); }}
            className="w-full text-right border border-gray-600 text-gray-300 px-4 py-1.5 rounded text-sm hover:border-brolax-red hover:text-brolax-red transition"
          >
            تسجيل خروج
          </button>
        </div>
      )}
    </nav>
  );
}